module.exports = __webpack_public_path__ + "img/icon-car.3bfeb432.svg";